import s from './Menu.module.css';
import Logo from '../../static/Logo.png';
import { VoitingButton } from './VoitingButton';
import { BreedsButton } from './BreedsButton';
import { GalleryButton } from './GalleryButton';
import { NavLink } from 'react-router-dom';

const Menu = () => {
  return (
    <div className={s.main__container}>
      <img src={Logo} alt="" className={s.logo} />
      <div className={s.container}>
        <h1 className={s.greeting}>Hi intern!</h1>
        <p className={s.text}>Welcome to MI 2022 Front-end test</p>
        <p className={s.text2}>Lets start using The Cat API</p>
        <div className={s.panel}>
          <NavLink to="/voiting">
            <VoitingButton />
          </NavLink>

          <NavLink to="/breeds">
            <BreedsButton />
          </NavLink>

          <NavLink to="/gallery">
            <GalleryButton />
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export { Menu };
